export const tags = [
  "enrollments-manager",
  "accommodations-modal",
  "unenroll-modal",
  "section-modal",
] as const;
